import styled from 'styled-components';

export const ContainerExt = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  margin: 16px;
  height: 100%;
  border-radius: 6px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: red;
  justify-content: center;
  align-items: center;
`;
export const Card = styled.div`
  width: 50%;
  height: 100vh;
  margin-top: 80px;
`;
export const ContainerLoading = styled.div`
  display: flex;
  height: 90vh;
  justify-content: center;
  align-items: center;
  `;

export const ScheduleContainer = styled.div`
  display: flex;
  flex-direction: row;
  border: solid 1px #C8C8C8;
`;
export const ScheduleContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const DayContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
export const Days = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 120px;
  margin: 0px 2px 0px 2px;
`;
export const ContainerBlocok = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const DayText = styled.div`
  font-size: 14px;
  padding: 5px;
  font-weight: 600;
  background-color: #E1E1E1;
  display: flex;
  width: 100%;
  border-radius: 2px;
  justify-content: center;
`;
export const DayByTurnContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  margin-left: 2px;
  width: 130px;
`;
export const TurnText = styled.div`
  font-size: 12px;
  padding: 2px;
  font-weight: 400;
  display: flex;
  width: 100%;
  border-radius: 2px;
  margin-top: 4px;
  margin-right: 4px;
  justify-content: center;
`;
export const ContainerColumBlock = styled.div`
  font-size: 14px;
  margin-right: 4px;
  font-weight: 400;
  padding-top: 4px;
  display: flex;
  flex-direction: column;
  width: 30%;
  border-radius: 2px;
`;
export const Block = styled.div`
  font-size: 14px;
  padding: 2px;
  font-weight: 400;
  background-color: #6FCF97;
  display: flex;
  cursor: pointer;
  width: 100%;
  height: 25px;
  border-radius: 2px;
  margin-bottom: 4px;
  justify-content: center;
`;
export const DayHeader = styled.div`
  display: flex;
  width: 100%;
  border-radius: 2px;
  font-weight: 600;
  padding: 5px;
  justify-content: center;
  font-size: 14px;
  margin-bottom: 2px;
  background-color: #C8C8C8;
`;
export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
export const TitleImovel = styled.div`
  font-size: 10px;
  font-weight: 800;
  background-color: #E1E1E1;
  display: flex;
  min-width: 175px;
  border-radius: 2px;
  word-break: break-all;
  align-items: center;
  justify-content: center;
  border: solid 0.1px #C8C8C8;
`;
export const Position = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 150px;
`;
